import PropTypes from "prop-types";
import { createContext, useContext, useState, useMemo } from "react";
import { initialFilterValues } from "./components/consolidated-stocks-filter/utils";

const LOCAL_STORAGE_KEY = "consolidatedStocksFilters";
const ConsolidatedStocksContext = createContext();

export const ConsolidatedStocksProvider = ({ children }) => {
  const [filter, setFilter] = useState(() => {
    try {
      const saved = localStorage.getItem(LOCAL_STORAGE_KEY);
      return saved ? JSON.parse(saved) : initialFilterValues;
    } catch {
      return initialFilterValues;
    }
  });

  const updateFilter = (newFilter) => {
    setFilter(newFilter);
    try {
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(newFilter));
    } catch { }
  };

  const [quantityRegisters, setQuantityRegisters] = useState(0);
  const [checkedItems, setCheckedItems] = useState([]);
  const [checkAll, setCheckAll] = useState(false);

  const contextValue = useMemo(
    () => ({
      filter,
      setFilter: updateFilter,
      quantityRegisters,
      setQuantityRegisters,
      checkedItems,
      setCheckedItems,
      checkAll,
      setCheckAll
    }),
    [filter, quantityRegisters, checkedItems, checkAll]
  );

  return (
    <ConsolidatedStocksContext.Provider value={contextValue}>
      {children}
    </ConsolidatedStocksContext.Provider>
  );
};

ConsolidatedStocksProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const useConsolidatedStocksContext = () => useContext(ConsolidatedStocksContext);